import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { OrderStatus } from "../storeHome/store/constants";
import RICBTEItemBuilder from "./components/RICBTEItemBuilder/RICBTEItemBuilder";
import ITEItemBuilder from "./components/ITEItemBuilder/ITEItemBuilder";
import EarPiecesItemBuilder from "./components/EarPiecesItemBuilder/EarPiecesItemBuilder";
import AccRgrChgItemBuilder from "./components/AccRgrChgItemBuilder/AccRgrChgItemBuilder";
import RepairItemBuilder from "./components/RepairItemBuilder/RepairItemBuilder";
import CustomHearingItemBuilder from "./components/CustomHearingItemBuilder/CustomHearingItemBuilder";
import ImplantItemBuilder from "./components/ImplantItemBuilder/ImplantItemBuilder";
import SwitchOnKitItemBuilder from "./components/SwitchOnKitItemBuilder/SwitchOnKitItemBuilder";
import WaterproofSolutionItemBuilder from "./components/WaterproofSolutionItemBuilder/WaterproofSolutionItemBuilder";
import LinkHearingItemBuilder from "./components/LinkHearingItemBuilder/LinkHearingItemBuilder";
import { find } from "lodash";
import Loading from "../../components/Loading/Loading";
import { OrderBuilderStatus } from "./store/constants";
import(/* webpackChunkName: "orderBuilder" */ "./orderBuilder.scss");

const OrderBuilder = ({
  featureFlags,
  loadOrderBuilder,
  loadItemComments,
  loadCheckboxSettings,
  orderBuilderStatus,
  orderBuilderData,
  itemCommentsData,
  checkboxSettingsStatus,
  checkboxSettingsData,
  profileData,
  configurationGroupStatus,
  configurationGroupData,
  configurationGroupLeft,
  configurationGroupRight,
  loadConfigurationGroup,
  customOptionsGroupStatus,
  customOptionsGroupData,
  customOptionsGroupLeft,
  customOptionsGroupRight,
  loadCustomOptionsGroup,
  productsData,
  cartStatus,
  addOrderToCart,
  cartData,
  isStockOrder,
  setIsStockOrder,
  loadPresets,
  presetsData,
  presetsStatus,
}) => {
  // console.log(document.location.pathname);

  const { categoryId, productId, itemId } = useParams();
  const isAdvancedBionicsRoute = [categoryId, productId].some((code) =>
    String(code || "").startsWith("AB_"),
  );
  const advancedBionicsCategory = [categoryId, productId].find((code) =>
    ["AB_Implant", "AB_SwitchKit", "AB_WaterPrf", "AB_Link"].includes(code),
  );
  const [builderType, setBuilderType] = useState();
  const [checkboxList, setCheckboxList] = useState();
  //console.log("Cat and prod:", categoryId,"-",productId, "-",itemId);

  useEffect(() => {
    if (loadCheckboxSettings) {
      loadCheckboxSettings();
    }
  }, [loadCheckboxSettings]);

  useEffect(() => {
    if (isAdvancedBionicsRoute && !featureFlags.AdvancedBionics) {
      return;
    }
    if (loadOrderBuilder && advancedBionicsCategory) {
      loadOrderBuilder(advancedBionicsCategory, productId);
      return;
    }
    if (loadOrderBuilder && productsData) {
      // console.log("productsData - 2", productsData);
      // console.log("productsData", productsData);
      // console.log("categoryId", categoryId);
      const productArray = find(productsData, { Code: categoryId });

      if (!productArray) return;
      if (productArray.InverseParentCodeNavigation.length > 0) {
        if (productId == "AccRgrChg") {
          const productType = find(
            productArray.InverseParentCodeNavigation,
            function (o) {
              return o.ParentCode === productId;
            }
          );
          loadOrderBuilder(productType.Type, productId);
        } else {
          // console.log("productId", productId);
          // console.log("productArray", productArray);
          // const productType = find(
          //   productArray.InverseParentCodeNavigation,
          //   function (o) {
          //     return o.Code === productId;
          //   }
          // );
          const productType = productArray.InverseParentCodeNavigation[0];
          // console.log("productArray", productArray);
          // console.log("productType", productType);
          // console.log("productId", productId);
          // console.log("itemId", itemId);
          // loadOrderBuilder(productType.Type, productId);
          loadOrderBuilder(productType.Type, productId);
        }
      } else {
        // console.log(categoryId, productId);
        loadOrderBuilder(categoryId, productId);
      }
    }
  }, [loadOrderBuilder, productsData, isAdvancedBionicsRoute, advancedBionicsCategory, categoryId, productId]);

  useEffect(() => {
    if (orderBuilderData) {
      if (orderBuilderData.Category) {
        if (orderBuilderData.Category.Type) {
          setBuilderType(orderBuilderData.Category.Type);
        }
      }
    }
  }, [orderBuilderData]);

  if (isAdvancedBionicsRoute && !featureFlags.AdvancedBionics) {
    return <Redirect to="/" />;
  }

  // Do not mount an AB form with the previous route's shared builder data.
  // Mounting only after its own data arrives also resets its local selections.
  if (advancedBionicsCategory) {
    if (orderBuilderStatus === OrderBuilderStatus.ERROR) {
      return <div className="alert alert-danger">The products could not be loaded. Please refresh to try again.</div>;
    }
    if (
      orderBuilderStatus !== OrderBuilderStatus.SUCCESS ||
      !orderBuilderData ||
      !orderBuilderData.Category ||
      orderBuilderData.Category.Code !== advancedBionicsCategory
    ) {
      return <Loading />;
    }
  }

  if (categoryId === "Repair") {
    // IF Repair selected from the home page / navbar, displays Repair builder
    return (
      <RepairItemBuilder
        cartData={cartData}
        productsData={productsData}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        checkboxSettingsData={checkboxSettingsData}
        checkboxSettingsStatus={checkboxSettingsStatus}
        profileData={profileData}
        loadOrderBuilder={loadOrderBuilder}
        loadCheckboxSettings={loadCheckboxSettings}
      />
    );
  }

  if (isStockOrder == OrderStatus.STOCK_ORDER) {
    return (
      <div className="order-builder-main-div">
        <h1>
          {categoryId === "Earpieces" && "Earpieces"}
          {categoryId === "AccRgrChg" && "Accessories / Roger / Chargers"}
        </h1>
        <div className="alert alert-danger" role="alert">
          <p>
            You cannot add items from this section because you have an ongoing
            stock order. Please clear your cart before proceeding.
          </p>
        </div>
      </div>
    );
  }

  // if (productId === "Earpiece") {
  if (categoryId === "Earpiece") {
    // if (categoryId === "Earpieces") {
    // IF earpieces selected from the home page / navbar, displays ear piece builder
    return (
      <EarPiecesItemBuilder
        productsData={productsData}
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        configurationGroupStatus={configurationGroupStatus}
        configurationGroupData={configurationGroupData}
        configurationGroupLeft={configurationGroupLeft}
        configurationGroupRight={configurationGroupRight}
        loadConfigurationGroup={loadConfigurationGroup}
        customOptionsGroupStatus={customOptionsGroupStatus}
        customOptionsGroupData={customOptionsGroupData}
        customOptionsGroupLeft={customOptionsGroupLeft}
        customOptionsGroupRight={customOptionsGroupRight}
        loadCustomOptionsGroup={loadCustomOptionsGroup}
        loadOrderBuilder={loadOrderBuilder}
        setIsStockOrder={setIsStockOrder}
      />
    );
  }

  //if (productId === "Earpiece") {
  if (categoryId === "CusHeaPro") {
    // IF earpieces selected from the home page / navbar, displays ear piece builder
    // console.log("categoryId", categoryId);
    // console.log("orderBuilderData", orderBuilderData);
    return (
      <CustomHearingItemBuilder
        productsData={productsData}
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        configurationGroupStatus={configurationGroupStatus}
        configurationGroupData={configurationGroupData}
        configurationGroupLeft={configurationGroupLeft}
        configurationGroupRight={configurationGroupRight}
        loadConfigurationGroup={loadConfigurationGroup}
        customOptionsGroupStatus={customOptionsGroupStatus}
        customOptionsGroupData={customOptionsGroupData}
        customOptionsGroupLeft={customOptionsGroupLeft}
        customOptionsGroupRight={customOptionsGroupRight}
        loadCustomOptionsGroup={loadCustomOptionsGroup}
        loadOrderBuilder={loadOrderBuilder}
        setIsStockOrder={setIsStockOrder}
      />
    );
  }

  if (categoryId === "AccRgrChg") {
    // IF AccRgrChg selected from the home page / navbar, displays AccRgrChg builder
    return (
      <AccRgrChgItemBuilder
        cartData={cartData}
        productsData={productsData}
        itemCommentsData={itemCommentsData}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        loadOrderBuilder={loadOrderBuilder}
        loadItemComments={loadItemComments}
        setIsStockOrder={setIsStockOrder}
      />
    );
  }

  if (categoryId === "AB_Implant" || productId === "AB_Implant") {
    return (
      <ImplantItemBuilder
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        setIsStockOrder={setIsStockOrder}
      />
    );
  }

  if (categoryId === "AB_SwitchKit" || productId === "AB_SwitchKit") {
    return (
      <SwitchOnKitItemBuilder
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        setIsStockOrder={setIsStockOrder}
        loadCustomOptionsGroup={loadCustomOptionsGroup}
        customOptionsGroupData={customOptionsGroupData}
        customOptionsGroupLeft={customOptionsGroupLeft}
        customOptionsGroupRight={customOptionsGroupRight}
        loadConfigurationGroup={loadConfigurationGroup}
        configurationGroupData={configurationGroupData}
        configurationGroupLeft={configurationGroupLeft}
        configurationGroupRight={configurationGroupRight}
      />
    );
  }

  if (categoryId === "AB_WaterPrf" || productId === "AB_WaterPrf") {
    return (
      <WaterproofSolutionItemBuilder
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        setIsStockOrder={setIsStockOrder}
        loadCustomOptionsGroup={loadCustomOptionsGroup}
        customOptionsGroupData={customOptionsGroupData}
        customOptionsGroupLeft={customOptionsGroupLeft}
        customOptionsGroupRight={customOptionsGroupRight}
        loadConfigurationGroup={loadConfigurationGroup}
        configurationGroupData={configurationGroupData}
        configurationGroupLeft={configurationGroupLeft}
        configurationGroupRight={configurationGroupRight}
      />
    );
  }

  if (categoryId === "AB_Link" || productId === "AB_Link") {
    return (
      <LinkHearingItemBuilder
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        setIsStockOrder={setIsStockOrder}
      />
    );
  }

  if (builderType === "ITE") {
    // IF item is an ITE hearing aid displayed ITE builder
    return (
      <ITEItemBuilder
        cartData={cartData}
        cartStatus={cartStatus}
        addOrderToCart={addOrderToCart}
        orderBuilderStatus={orderBuilderStatus}
        orderBuilderData={orderBuilderData}
        configurationGroupStatus={configurationGroupStatus}
        configurationGroupData={configurationGroupData}
        configurationGroupLeft={configurationGroupLeft}
        configurationGroupRight={configurationGroupRight}
        loadConfigurationGroup={loadConfigurationGroup}
        customOptionsGroupStatus={customOptionsGroupStatus}
        customOptionsGroupData={customOptionsGroupData}
        customOptionsGroupLeft={customOptionsGroupLeft}
        customOptionsGroupRight={customOptionsGroupRight}
        loadCustomOptionsGroup={loadCustomOptionsGroup}
        setIsStockOrder={setIsStockOrder}
        checkboxSettingsData={checkboxSettingsData}
        loadPresets={loadPresets}
        presetsData={presetsData}
        presetsStatus={presetsStatus}
      />
    );
  }

  // If item is not an ITE hearing aid or ear piece, displays RIC/BTE builder
  // console.log("orderBuilderData", orderBuilderData);
  return (
    <RICBTEItemBuilder
      cartData={cartData}
      cartStatus={cartStatus}
      addOrderToCart={addOrderToCart}
      orderBuilderStatus={orderBuilderStatus}
      orderBuilderData={orderBuilderData}
      setIsStockOrder={setIsStockOrder}
    />
  );
};

OrderBuilder.propTypes = {
  loadOrderBuilder: PropTypes.func,
  loadCheckboxSettings: PropTypes.func,
  orderBuilderStatus: PropTypes.string,
  orderBuilderData: PropTypes.any,
  configurationGroupStatus: PropTypes.string,
  configurationGroupData: PropTypes.object,
  configurationGroupLeft: PropTypes.object,
  configurationGroupRight: PropTypes.object,
  loadConfigurationGroup: PropTypes.func,
  customOptionsGroupStatus: PropTypes.string,
  customOptionsGroupData: PropTypes.object,
  customOptionsGroupLeft: PropTypes.array,
  customOptionsGroupRight: PropTypes.array,
  loadCustomOptionsGroup: PropTypes.func,
  productsData: PropTypes.array,
  cartStatus: PropTypes.string,
  addOrderToCart: PropTypes.func,
  cartData: PropTypes.array,
  isStockOrder: PropTypes.string,
  profileData: PropTypes.object,
  presetsData: PropTypes.object,
  presetsStatus: PropTypes.object,
};

export default OrderBuilder;
